<!--@keyup="$emit('update:data1', $event.target.value)"-->
<template>
    <div id="itemPrixParQuantite">

        <h6 class="subTitle3 cursorPoint" @mousedown="collaps = !collaps">{{collaps == true ? '-' : '+'}} {{$t('i_PrixParQuantite')}}</h6>
            <span v-show="collaps">
                <!--Titre-->
                <b-row align-v="center">
                    <b-col class="MargeLeft15 prQte" cols=4><b-row>Quantité >=</b-row></b-col>
                    <b-col class="prQte" cols=4><b-row>Prix un.</b-row></b-col>
                </b-row> 

                <!--Prix par quantité 1-->
                <b-row align-v="center">
                    <b-col :cols="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" append="$" v-model="_PrixQteQ1"></s-currencyInput>
                        </b-row>
                    </b-col>
                    <b-col :cols="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" append="$" v-model="_PrixQteP1"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <!--Prix par quantité 2-->
                <b-row align-v="center">
                    <b-col :cols="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" append="$" v-model="_PrixQteQ2"></s-currencyInput>
                        </b-row>
                    </b-col>
                    <b-col :cols="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" append="$" v-model="_PrixQteP2"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <!--Prix par quantité 3-->
                <b-row align-v="center">
                    <b-col :cols="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" append="$" v-model="_PrixQteQ3"></s-currencyInput>
                        </b-row>
                    </b-col>
                    <b-col :cols="prixSize.prix">
                        <b-row align-v="center">
                            <s-currencyInput class="Prix" append="$" v-model="_PrixQteP3"></s-currencyInput>
                        </b-row>
                    </b-col>
                </b-row>

                <!--Paquet-->
                <b-form-checkbox switch :size="chkSize" v-model="_PrixPaquet">{{$t('i_Paquet')}}</b-form-checkbox>
                
            </span>

    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default{
    name: 'itemPrixParQuantite',
    components: {

},
    props: ['PrixQteQ1', 'PrixQteP1', 
            'PrixQteQ2', 'PrixQteP2', 
            'PrixQteQ3', 'PrixQteP3',
            'PrixPaquet',
            'prixSize', 'chkSize'],
    data() {
        return {
            collaps: false,
        }
    },
    methods: {

    },
    computed: {
        ...mapGetters(['getTheme']),
        _PrixQteQ1: {
            get: function() {return this.PrixQteQ1},
            set: function(modifiedValue){this.$emit('update:PrixQteQ1', modifiedValue)}
        },
        _PrixQteP1: {
            get: function() {return this.PrixQteP1},
            set: function(modifiedValue){this.$emit('update:PrixQteP1', modifiedValue)}
        },
        _PrixQteQ2: {
            get: function() {return this.PrixQteQ2},
            set: function(modifiedValue){this.$emit('update:PrixQteQ2', modifiedValue)}
        },
        _PrixQteP2: {
            get: function() {return this.PrixQteP2},
            set: function(modifiedValue){this.$emit('update:PrixQteP2', modifiedValue)}
        },
        _PrixQteQ3: {
            get: function() {return this.PrixQteQ3},
            set: function(modifiedValue){this.$emit('update:PrixQteQ3', modifiedValue)}
        },
        _PrixQteP3: {
            get: function() {return this.PrixQteP3},
            set: function(modifiedValue){this.$emit('update:PrixQteP3', modifiedValue)}
        },
        _PrixPaquet: {
            get: function() {return this.PrixPaquet},
            set: function(modifiedValue){this.$emit('update:PrixPaquet', modifiedValue)}
        }
    }
}
</script>

<style lang="scss" scoped>

</style>